'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DatePickerWrapper;
var _react = _interopRequireWildcard(require("react"));
var _LocalizationProvider = require("@mui/x-date-pickers/LocalizationProvider");
var _AdapterMoment = require("@mui/x-date-pickers/AdapterMoment");
var _DatePicker = require("@mui/x-date-pickers/DatePicker");
var _TextField = _interopRequireDefault(require("@mui/material/TextField"));
var _FormHelperText = _interopRequireDefault(require("@mui/material/FormHelperText"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function DatePickerWrapper(props) {
  const [value, setValue] = (0, _react.useState)(props.value || undefined);
  let error_msg,
    status = props.status[props.name] || {};
  (0, _react.useEffect)(() => {
    if (props.value !== undefined && props.value !== value) {
      setValue(props.value);
    }
  }, [props.value]);
  if (status && status.error) {
    error_msg = /*#__PURE__*/_react.default.createElement(_FormHelperText.default, {
      error: true
    }, status.error);
  }
  const output = /*#__PURE__*/_react.default.createElement(_LocalizationProvider.LocalizationProvider, {
    dateAdapter: _AdapterMoment.AdapterMoment
  }, /*#__PURE__*/_react.default.createElement(_DatePicker.DatePicker, {
    label: props.label,
    value: value || null,
    variant: "Standard",
    onChange: new_value => {
      var _new_value$format;
      props.onChange({
        value: (new_value === null || new_value === void 0 ? void 0 : (_new_value$format = new_value.format) === null || _new_value$format === void 0 ? void 0 : _new_value$format.call(new_value, 'YYYY-MM-DD')) || null,
        name: props.name,
        error_name: getStatusName()
      });
    },
    renderInput: params => /*#__PURE__*/_react.default.createElement(_TextField.default, params)
  }), error_msg);
  return output;
  function getStatusName() {
    var _props$name;
    return !props['error-prefix'] ? props.name : ((_props$name = props.name) === null || _props$name === void 0 ? void 0 : _props$name.includes('[')) === true ? props['error-prefix'] + '[' + props.name.replace('[', '][') : props['error-prefix'] + '[' + props.name + ']';
  }
}
